import Icon from '../icon/Icon';
import { Wrapper } from './DefaultLogo.styles';

interface DefaultLogo {
  size: 'sm' | 'lg' | 'xxl';
}

const DefaultLogo = ({ size }: DefaultLogo): JSX.Element => {
  return (
    <Wrapper size={size}>
      <Icon
        type="ship"
        size={size}
        color="white"
        alt="Thumbnail placeholder featuring a ship representing the company's logo"
      />
    </Wrapper>
  );
};

export default DefaultLogo;
